import React from 'react';
import PropTypes from 'prop-types';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { useIdentityChallengeContext } from 'Context/IdentityChallengeContext';
import { dispatchModalContextSubmissionSuccessful } from 'Hooks/useRefreshEvent';
import Sentry from 'Integrations/Sentry';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';


const ModalForm2 = ({
  Layout,
  metaOverrideSet,
}) => {
  const {
    modalCollection,
    setModalCollection,
  } = useModalContext();
  const { displayErrorMessage } = useSnackbarContext();
  const { handleInterceptResponse } = useIdentityChallengeContext();

  if (!modalCollection) {
    return null;
  }

  return (
    <MetaResourceRenderer
      key={modalCollection.link('self').url()}
      layout={Layout}
      metaOverrideSet={metaOverrideSet}
      resource={modalCollection.resources().head()}
      onSubmit={(possiblyDicrsResponse, argsOrIndex, args) => {
        return handleInterceptResponse(possiblyDicrsResponse, (originalRequestResponse) => {
          try {
            setModalCollection(originalRequestResponse);
          } catch (err) {
            Sentry.createSentryErrorLog(err);
            throw err;
          }
          dispatchModalContextSubmissionSuccessful(originalRequestResponse, typeof argsOrIndex === 'number' ? args : argsOrIndex);
          return originalRequestResponse;
        },
        (err) => {
          displayErrorMessage(err, err.errors);
        });
      }}
    />
  );
};

ModalForm2.propTypes = {
  metaOverrideSet: PropTypes.object.isRequired,
  Layout: PropTypes.object.isRequired,
};

export default ModalForm2;
